module.exports = __webpack_public_path__ + "img/rescue_truck_h.c90d543b.png";